const getDbnsfp = (state) => state.variantResult && state.variantResult.dbnsfp;

const getDann = (state) => state.variantResult && state.variantResult.dann_snvs;

const getCadd = (state) => state.variantResult && state.variantResult.cadd;

const getDbnsfpPremium = (state) =>
  state.variantResult && state.variantResult.dbnsfp_premium;

const getDbnsfpDbscsnv = (state) =>
  state.variantResult && state.variantResult.dbnsfp_dbscsnv;

const getSchemaProperties = (state) => state.schema && state.schema.properties;

export {
  getDbnsfp,
  getSchemaProperties,
  getDann,
  getCadd,
  getDbnsfpPremium,
  getDbnsfpDbscsnv,
};
